import eventBus, {GET_USER_INFO_SUCCESS} from '@/eventBus';
import sdk from '@/sdk';
import {WizRequestOptions} from '@/interface';

const server = {
    // 插件封装 asServer请求
    asRequest: async (options: WizRequestOptions) => {
        return new Promise((resolve, reject) => {
            const request = () => {
                return sdk.as.request({
                    ...options,
                    wikiToken: sdk.as.user?.token,
                })
                    .then((data) => resolve(data))
                    .catch((error) => reject(error));
            };

            if (sdk.as.user) {
                request();
            } else {
                eventBus.once(GET_USER_INFO_SUCCESS, request);
            }
        });
    },
    // 插件封装 ksServer请求
    ksRequest: async (options: WizRequestOptions, repository?: Repository) => {
        return new Promise((resolve, reject) => {
            const request = async () => {
                const ksServer = await sdk.getKsServer(repository);
                return ksServer.request(options)
                    .then((data) => resolve(data))
                    .catch((error) => reject(error));
            };

            if (sdk.as.user) {
                request();
            } else {
                eventBus.once(GET_USER_INFO_SUCCESS, request);
            }
        });
    },
};

export default server;
